import React from "react";
import { connect } from "react-redux";
import { withFormik, Form, Field } from 'formik';
import * as Yup from 'yup';
 
import Button from "../../common/button/Button";
import { authenticate, setErrorMsg } from "../../actions/auth.js";

import MdClose from 'react-icons/lib/md/close';
import MdLockOutline from "react-icons/lib/md/lock-outline";
import MdPersonOutline from "react-icons/lib/md/person-outline";

import BrowserHistory from '../../providers/BrowserHistory';

import './LoginForm.css';

// import fakeAuth from '../../fakeAuth';

const LoginForm = props => {
	const {	
	values,
	errors,
	touched,
} = props; 

	return	(
	<div id="login-form">
	<div className="header">
		<img
			src="https://eldocs.net/eldocs-logo-dark.png"
			className="logo"
			alt="eldocs-logo"
		/>
	</div>

	<Form>
		<div
			className="form-row text-center"
			style={{ color: "rgb(70, 108, 149)" }}
		>
			<h1>Start Working</h1>
		</div>
		<div className="form-row">
			<div className="input-container">
				<div className="input left-padding right-padding">
					<div className="icon">
						<MdPersonOutline size="18" />
					</div>
					<Field className={touched.email && errors.email ? 'error' : ''} type="text" name="email" placeholder="Email"/>
					{ touched.email && errors.email && <div className="field-error">{errors.email}</div>}
				</div>
			</div>
		</div>
		<div className="form-row">
			<div className="input-container">
				<div className="input left-padding right-padding">
					<div className="icon">
						<MdLockOutline size="18" />
					</div>
					<Field className={touched.password && errors.password ? 'error' : ''} type="password" name="password" placeholder="Password"/>
					{ touched.password && errors.password && <div className="field-error">{errors.password}</div>}
				</div>
			</div>
		</div>
		{ 	
			values.email!='' && values.password!='' && props.data.auth.error && 
			<div className="form-row errorMessage">
				<span>Email or Password is Incorrect</span>
				<MdClose size="18" style={{cursor:"pointer"}} onClick={()=>props.setErrorMsg(false)}/>
			</div>
		}
		{/* <div className="form-row">
			<Input
				ph="username"
				type="email"
				thumbnail={thumbnail}
				onChange={this.handleChange}
				value={this.state.email}
			>
				<MdPersonOutline size="18" />
			</Input>
			<Button
				className="btn-inside-right"
				onClick={e => {
					this.handleDelete("email", e);
				}}
			>
				<MdClose size="18" color="rgb(70, 108, 149)" />
			</Button>
		</div>
		<div className="form-row">
			<Input ph="password" type="password" value={this.state.password} onChange={this.handleChange}>
				<MdLockOutline size="18" />
			</Input>
		</div> */}
		<div className="form-row">
			<Button
				onClick={onForgotPasswordClick}
				className="btn-plain forgot-password"
			>
				forgot password?
			</Button>
			<Button
				type="submit"
				className="btn-green btn-darkBlue btn-stretch"
			>
				SIGN IN
			</Button>
		</div>
	</Form>
</div>
);
};

	const onForgotPasswordClick = e => {
		e.preventDefault();
		BrowserHistory.push("/forgot-password");
	};

	// const { email, thumbnail } = this.state;
	// if (this.state.shouldRedirect) {
	// 	console.log("redirect happened");
	// 	return <Redirect to={this.props.redirect} />;
	// }

const FormikApp = withFormik({
	mapPropsToValues({ email, password }) {
		return {
			email: email || '',
			password: password || ''
		}
	},
	validationSchema: Yup.object().shape({
		email: Yup.string().email('Insert Correct Email').required('Email is Required'),
		password: Yup.string().required('Password is Requierd')
	}),
	handleSubmit(values, {props}) {
		props.authenticate(values.email, values.password);
	}
})(LoginForm)

const mapStateToProps = state => {

	return {
		data: state
	};
};

// export default LoginForm;
export default connect(
	mapStateToProps,
	{ authenticate, setErrorMsg }
)(FormikApp)

// export default connect(auth
// )(LoginForm);


// WEBPACK FOOTER //
// ./src/components/login/LoginForm.js